import { render, staticRenderFns } from "./ObligationStatus.vue?vue&type=template&id=df89b978"
import script from "./ObligationStatus.vue?vue&type=script&lang=js"
export * from "./ObligationStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports